import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Pagination, Form, FormGroup, Popover, OverlayTrigger, Button } from 'react-bootstrap'
import { momentHelper } from '../helpers'
import SelectDate from 'component/element/SelectDate'
import PrintButtons from 'component/element/PrintButtons'
import ReportStore from 'stores/ReportStore'
// import StockStore from 'stores/StockStore'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import FontAwesome from 'react-fontawesome'
import DatePicker from 'component/element/DatePicker'
import IframeModal from 'component/element/IframeModal'
import Moment from 'moment'
import '../report.css'
const WHOLE_YEAR = momentHelper.getMonth() //'00'

class ReportStockCard extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      loading:false,
      activePage:1,
      // groupId:'all',
      // groupList:[{label:'เลือกทั้งหมด',value:'all'}],
      month:WHOLE_YEAR,
      year:momentHelper.getYear(),
      data:[],
      isRange:false,
      day:momentHelper.getDay(),
      dayRange:momentHelper.getDay(),
      monthRange:WHOLE_YEAR,
      yearRange:momentHelper.getYear(),
      check_date:[],
      dataFormat:[]
    }
    this.refTableId = 'ReportStockCard-'+Math.ceil(Math.random()*100);
  }

  componentDidMount(){
   
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData(this.state.year,this.state.month,this.state.day)
      // this.loadCategory()
    }
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSummary(field) {
    let {data} = this.state
    let total = 0
    data.forEach((item,index)=> {
        total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
    }) 
    return total
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth()
    if (all_day) {
      if (all_day<this.state.day) {
        var defaultDay = '00'
      } else {
        var defaultDay = this.state.day
      }
    } else {
      var defaultDay = '00'
    }
    return defaultDay
  }

  setItem(result) {
        this.setState({loading:false})
        let that = this
        let {check_date,dataFormat} = this.state
        var id = []
        var itemnum = []
        var bill_type = []
        var added_date = []
        var in_quantity = []
        var out_quantity = []
        var balance_quantity = []
        var sum_in_quantity = 0
        var sum_out_quantity = 0
        var sum_balance_quantity = 0

        that.setState({data:[], dataFormat:[], check_date:[]})

        for (var ii=0;ii<result.data.length;ii++) {
          if (check_date.indexOf(result.data[ii].description)===-1) {
            check_date.push(result.data[ii].description)
          }
        }

        for (var i=0;i<check_date.length;i++) {
          let left_in = 0,left_out=0;
          for (var j=0;j<result.data.length;j++) {            
            if (check_date[i]===result.data[j].description) {
              if(result.data[j].record_type=='left_balance'){
                left_in = result.data[j].in_quantity;
                left_out= result.data[j].out_quantity;
              }
              id.push(result.data[j].ref_bill_no)
              itemnum.push(result.data[j].itemnum)
              added_date.push(result.data[j].added_date)
              bill_type.push(result.data[j].bill_type)
              in_quantity.push(result.data[j].in_quantity===undefined?0:result.data[j].in_quantity)
              out_quantity.push(result.data[j].out_quantity===undefined?0:result.data[j].out_quantity)
              balance_quantity.push(result.data[j].balance_quantity)
              sum_in_quantity = (sum_in_quantity*1) + ((result.data[j].in_quantity===undefined?0:result.data[j].in_quantity)*1)
              sum_out_quantity = (sum_out_quantity*1) + ((result.data[j].out_quantity===undefined?0:result.data[j].out_quantity)*1)
            }
          }

          sum_in_quantity = sum_in_quantity - left_in
          sum_out_quantity =sum_out_quantity - left_out
          sum_balance_quantity = sum_in_quantity - sum_out_quantity
          dataFormat.push({
            description: check_date[i],
            meta: {
              id: id,
              itemnum: itemnum,
              bill_type: bill_type,
              added_date: added_date,
              in_quantity: in_quantity,
              out_quantity: out_quantity,
              balance_quantity: balance_quantity
            },
            sum_in_quantity: sum_in_quantity ,
            sum_out_quantity: sum_out_quantity ,
            sum_balance_quantity:  sum_balance_quantity
          })
          id = []
          itemnum = []
          bill_type = []
          added_date = []
          in_quantity = []
          out_quantity = []
          balance_quantity = []
          sum_in_quantity = 0
          sum_out_quantity = 0
          sum_balance_quantity = 0
        }

        that.setState({data:dataFormat, dataFormat:[], loading:false})
  }

  loadData(year='',month='',day='') {  
    let that = this
    that.setState({loading:true,isRange:false,dayRange:momentHelper.getDay(),monthRange:month,yearRange:year})
    ReportStore.loadReportStockCard(year, month, day, '', '', function(result) {
      that.setItem(result)
    })  
  }

  loadDataRange(start='',end='') {
    let that = this
    ReportStore.loadReportStockCardRange(start, end, '', '', function(result) {
      that.setItem(result)
    })
  }

  onIconClick(workNo,e) {
    if(this.props.onWorkClick!==undefined){
      this.props.onWorkClick(workNo)
    }
  }

  renderBody() {
    let {data} = this.state
    var sum_all_day = 0
    if (this.state.data.length>0) {
      return(
        data.map((item, i) => {
          sum_all_day = (sum_all_day*1) + (item.sum_balance_quantity*1)
          var check_last = "none" 
          if (i===this.state.data.length-1) {
            check_last = ""
          }
          return(
            <tr key={i}>
              <td className='text-left'>
                <div className="bd-date"><b>{item.description}</b></div>
                {
                  item.meta.added_date.map((added_date, index) => {
                    return(
                      <div key={index}>
                        <div>{index}. {added_date}</div>
                      </div>
                    )
                  })  
                }
              </td>
              <td className='text-center'>
                <div className="bd-date"><br/></div>
                {
                  item.meta.id.map((id, index) => {
                    let title = "เลขที่บิล "+id
                    let popoverHoverFocus = (
                      <Popover id="popover-trigger-hover-focus" title={title}>
                        <strong>คลิกตรงไอค่อนเพื่อเข้าดูใบงาน</strong>
                      </Popover>
                    )
                    return(
                      <div key={index}>
                        {id===''?'-'
                        :
                        <div>
                          {id} &nbsp;
                          <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popoverHoverFocus}>
                            <FontAwesome onClick={this.onIconClick.bind(this,id)} className="text-blue" name='file-text-o'/>
                          </OverlayTrigger>
                        </div>}
                      </div>
                    )
                  })  
                }
              </td>
              <td className='text-center'>
                <div className="bd-date"><br/></div>
                {
                  item.meta.bill_type.map((bill_type, index) => {
                    return(
                      <div key={index}>
                        <div>{bill_type}</div>
                      </div>
                    )
                  })  
                }
              </td>
              <td>
                <div className="bd-date"><br/></div>
                {
                  item.meta.itemnum.map((itemnum, index) => {
                    let bd_sum = ""
                    if (index===item.meta.itemnum.length-1) {
                      bd_sum = "bd-sum"
                    }

                    return(
                      <div key={index} className={bd_sum}>
                        <div><br/></div>
                      </div>
                    )
                  })
                }
                <div className="bd-sum"><b>รวม/วัน</b></div>  
                <div style={{display:check_last}} className="bd-sum text-left"><b>ยอดรวมสุทธิ</b></div>
              </td>
              <td className="text-center">
                <div className="bd-date"><br/></div>
                {
                  item.meta.in_quantity.map((in_quantity, index) => {
                    let bd_sum = ""
                    if (index===item.meta.in_quantity.length-1) {
                      bd_sum = "bd-sum"
                    }

                    return(
                      <div key={index} className={bd_sum}>
                        <div>{this.getNumberFormat(in_quantity)}</div>
                      </div>
                    )
                  })
                }
                <div className="bd-sum">{this.getNumberFormat(item.sum_in_quantity)}</div>  
                <div style={{display:check_last}} className="bd-sum"><br/></div> 
              </td>
              <td className="text-center">
                <div className="bd-date"><br/></div>
                {
                  item.meta.out_quantity.map((out_quantity, index) => {
                    let bd_sum = ""
                    if (index===item.meta.out_quantity.length-1) {
                      bd_sum = "bd-sum"
                    }

                    return(
                      <div key={index} className={bd_sum}>
                        <div>{this.getNumberFormat(out_quantity)}</div>
                      </div>
                    )
                  })
                }
                <div className="bd-sum">{this.getNumberFormat(item.sum_out_quantity)}</div>
                <div style={{display:check_last}} className="bd-sum"><br/></div> 
              </td>
              <td className="text-center">
                <div className="bd-date"><br/></div>
                {
                  item.meta.balance_quantity.map((balance_quantity, index) => {
                    let bd_sum = ""
                    if (index===item.meta.balance_quantity.length-1) {
                      bd_sum = "bd-sum"
                    }

                    return(
                      <div key={index} className={bd_sum}>
                        <div>{this.getNumberFormat(balance_quantity)}</div>
                      </div>
                    )
                  })
                }
                <div className="bd-sum">{this.getNumberFormat(item.sum_balance_quantity)}</div>
                <div style={{display:check_last}} className="bd-sum"><b>{this.getNumberFormat(sum_all_day)}</b></div>
              </td>
            </tr>
          )
        })      
      )
    } else {
      return(<tr><td colSpan={7}>ไม่พบข้อมูล</td></tr>)
    }
  }

  getDate() {
    let {day,year,month,isRange,dayRange,monthRange,yearRange} = this.state
    if (isRange) {
      let start = (day<10?'0'+day:day)+'/'+(month=='00'?'1':month)+'/'+year
      let end = dayRange+'/'+(monthRange<10?'0'+monthRange:monthRange)+'/'+yearRange
      return 'ประจำวันที่ '+start+' - '+end
    } else {
      let text = 'ประจำวันที่ '
      text += day+' '+momentHelper.getMonthText(month)+' '+year
      if (year==='0'||year==='00') {
        text = 'ทั้งหมด'
      } else if (month==='0'||month==='00') {
        text = 'ประจำปี '+year
      } else if (day==='0'||day==='00') {
        text = 'ประจำเดือน '+momentHelper.getMonthText(month)+' '+year
      }
      return text
    }  
  }

  renderTable() {
    return (
      <div className='display-overflow'>
        <table id={this.refTableId} className='table table-responsive table-bordered-solid table-report-profit'>
          <thead>
            <tr>
              <th style={{display:'none'}} colSpan={7}>รายงานความเคลื่อนไหวของสต็อก (Stock Card) {this.getDate()}</th>
            </tr>
            <tr>
              <th style={{width:"200px"}}></th>
              <th style={{width:"100px"}} className="text-center">เลขที่บิล</th>
              <th style={{width:"80px"}} className="text-center">ประเภทบิล</th>
              <th style={{width:"50px"}}></th>
              <th style={{width:"90px"}} className="text-center">จำนวนเข้า</th>
              <th style={{width:"90px"}} className="text-center">จำนวนออก</th>
              <th style={{width:"90px"}} className="text-center">คงเหลือ</th>
            </tr>
          </thead>
          <tbody>
            {this.renderBody()}
          </tbody>
        </table>
      </div>
    )
  }

  onPageSelect(eventKey) {
    this.setState({
      activePage: eventKey
    })
    // next... load new page
  }

//   onGroupChange(val) {
//     this.setState({
//       groupId: val.value
//     })
//     this.loadData(val.value)
//   }

  onDayChange(val){
    this.setState({
      day: val.value, isRange:false
    })
    this.loadData(this.state.year,this.state.month,val.value)
  }

  onMonthChange(val) {
    let date = this.state.year-543+'-'+val.value
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      month: val.value, isRange: false, day:_day
    })
    this.loadData(this.state.year,val.value,_day)
  }

  onYearChange(val) {
    let date = val.value-543+'-'+this.state.month
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      year: val.value, isRange: false, day:_day
    })
    this.loadData(val.value,this.state.month,_day)
  }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = 'รายงานความเคลื่อนไหวของสต็อก (Stock Card).xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  onPrintTable(e) {
    const {isRange} = this.state
    let url = ''
    let param = 'PrintReportStockCard&year='+this.state.year+'&month='+this.state.month+'&day='+this.state.day+'&isRange=false'
    if (isRange) {
        let {day,month,year,dayRange,monthRange,yearRange} = this.state
        let start = (day<10?'0'+day:day)+'/'+(month=='00'?'1':month)+'/'+(year-543)
        let end = dayRange+'/'+(monthRange<10?'0'+monthRange:monthRange)+'/'+(yearRange-543)
        param = 'PrintReportStockCard&start_date='+start+'&end_date='+end+'&isRange=true'
    }    

    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  onStartDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let _day = time.substr(0,2)
      let _month = time.substr(3,2)
      let _year = time.substr(6,10)
      this.setState({day:_day*1,month:_month,year:_year*1,isRange:false})
      this.loadData(_year,_month,_day)
    }
  }

  onEndDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let {day,month,year} = this.state
      let _day = parseInt(time.substr(0,2))
      let _month = parseInt(time.substr(3,5))
      let _year = parseInt(time.substr(6,10))
      this.setState({isRange:true,dayRange:_day,monthRange:_month,yearRange:_year})
      year = year - 543
      _year = _year - 543
      let start = day+'/'+(month=='00'?'1':month)+'/'+year
      let end = _day+'/'+_month+'/'+_year
      this.loadDataRange(start,end)
    }  
  }

  onRangeChange(fromDateString,toDateString,items) {
    let {day,month,year,dayRange,monthRange,yearRange} = this.state
    day = items.from.format('DD')*1
    month = items.from.format('MM')
    year = (items.from.format('YYYY')*1)+543
    dayRange = items.to.format('DD')*1
    monthRange = items.to.format('MM')
    yearRange = (items.to.format('YYYY')*1)+543
    this.setState({isRange:true,day:day,month:month,year:year,dayRange:dayRange,monthRange:monthRange,yearRange:yearRange})
    const start = day+'/'+month+'/'+items.from.format('YYYY')
    const end = dayRange+'/'+monthRange+'/'+items.to.format('YYYY')
    this.loadDataRange(start,end)
  }

  renderWCalendar() {
    return(
      <div style={{display:'inline-flex'}}>
        <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.day=='00'?momentHelper.getDay():this.state.day)+'/'+(this.state.month=='00'?WHOLE_YEAR:this.state.month)+'/'+this.state.year}
                onChange={this.onStartDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
          <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.dayRange=='00'?momentHelper.getDay():this.state.dayRange)+'/'+(this.state.monthRange=='00'?WHOLE_YEAR:this.state.monthRange)+'/'+this.state.yearRange}
                onChange={this.onEndDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
      </div>
    )
  }

  renderToolbar() {
    return(
      <Form inline style={{marginBottom:'5px'}}>
        <FormGroup style={{verticalAlign:'top'}}>
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            day={this.state.day}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
            onDayChange={this.onDayChange.bind(this)}
            dayWCalendar={true}
            renderWCalendar={this.renderWCalendar.bind(this)}
          />
        </FormGroup>
        <FormGroup style={{verticalAlign:'top',marginLeft:'5px',marginTop:'1.5px'}}>
          <PrintButtons
            onPrintTable={this.onPrintTable.bind(this)}
            onExportExcel={this.onExportExcel.bind(this)}
            marginLeft='0'
            width='auto'
          />
        </FormGroup>
      </Form>
    )
  }

  renderPaging() {
    return (
      <div className="text-center pull-right">
        <Pagination
          prev
          next
          first
          last
          bsSize="medium"
          items={5}
          activePage={this.state.activePage}
          onSelect={this.onPageSelect.bind(this)} />
      </div>
    )
  }

  getStartDateRangeText() {
    let {day,month,year} = this.state
    let txtMonth = momentHelper.getMonthText(month.toString())
    return day*1+' '+ txtMonth +' '+ year
  }

  getEndDateRangeText() {
    let {dayRange,monthRange,yearRange} = this.state
    dayRange = dayRange==0?1:dayRange
    let txtMonth = momentHelper.getMonthText(monthRange.toString())
    return dayRange +' '+ txtMonth +' '+ yearRange
  }

  onRangeClearClick() {
    this.loadData(this.state.year,this.state.month,this.state.day)
    this.setState({isRange:false,dayRange:momentHelper.getDay(),monthRange:this.state.month,yearRange:this.state.year})
  }

  renderDateRange() {
    let {isRange} = this.state
    if (isRange) {
      return(
        <div style={{marginBottom:'10px',display:'flex'}}>
          {this.getStartDateRangeText()} - {this.getEndDateRangeText()}&nbsp;<Button className='btn btn-xs' onClick={this.onRangeClearClick.bind(this)}><FontAwesome name='eraser' />&nbsp;ลบช่วงเวลา</Button>
        </div>
      )
    } else {
      return('')
    }  
  }

  render() {
    const {loading} = this.state
    return (
      <Box loading={loading}>
        <Box.Header border={true}>          
          {this.props.renderMenu()}
        </Box.Header>
        <Box.Body>
          {this.renderToolbar()}
          {this.renderDateRange()}
          {this.renderTable()}
          {/* this.renderPaging() */}
          <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        </Box.Body>
      </Box>
    )
  }
}

ReportStockCard.defaultProps = {
  show : false
}

export default ReportStockCard;


// WEBPACK FOOTER //
// ./src/view/report/stock/ReportStockCard.js